const checkbox = document.getElementById("menu-toggle"),
  nav = document.querySelector(".header__navegacion"),
  icono = document.querySelector(".menu-icono"),
  btnFiltros = document.getElementById("btnFiltros"),
  filtrosMovil = document.getElementById("filtrosMovil"),
  inputFile = document.getElementById("subeImagen"),
  formulario = document.getElementById("formularioSubirFotos"),
  tokenActual = document.getElementById("token")?.value || "";

const TOKENS_DEMO = ["69c30277443a4", "633b84a30d13d", "63fa8ef4782f8"];
function esModoDemo(tokenActual) {
  return TOKENS_DEMO.includes(tokenActual);
}

// Inicia Documento
document.addEventListener("DOMContentLoaded", () => {
  iniciarApp();
});

function iniciarApp() {
  bloquearClickCierre(icono);
  bloquearClickCierre(checkbox);
  bloquearClickCierre(nav);
  cerrarHmbMenu();
  verFiltrosMovil();
  iniciaFoto();
  empiezaCargaFotos();
  filtrosInvitados();
  descargaFotos();
  cierraAlertaExpiracion();
  contadorAlertaExpiracion();
}

function iniciarScrollReveal() {
  ScrollReveal().clean(".modelo");

  ScrollReveal().reveal(".modelo", {
    opacity: 1,
    distance: "0px",
    duration: 0,
    viewFactor: 0.4,
    viewOffset: { top: 100 },
    beforeReveal: (el) => {
      el.classList.remove("scale-up-center");
      void el.offsetWidth;
      el.classList.add("scale-up-center");
    },
  });
}

function bloquearClickCierre(element) {
  element.addEventListener("click", (e) => e.stopPropagation());
}

function cerrarHmbMenu() {
  // Cerrar menú al dar click fuera o al hacer scroll
  document.addEventListener("click", () => (checkbox.checked = false));
  window.addEventListener("scroll", () => (checkbox.checked = false));
}

function verFiltrosMovil() {
  btnFiltros.addEventListener("click", (e) => {
    e.stopPropagation();
    filtrosMovil.classList.toggle("abierto");
  });

  // Cerrar filtros móvil al hacer click fuera
  document.addEventListener("click", (e) => {
    if (!filtrosMovil.contains(e.target) && !btnFiltros.contains(e.target)) {
      filtrosMovil.classList.remove("abierto");
    }
  });
}

function iniciaFoto() {
  inputFile.addEventListener("change", async function () {
    let file = this.files[0];
    if (!file) return;

    const MAX_SIZE_MB = 20;

    // validar tamaño
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Imagen muy grande",
        text: "La imagen no debe superar los 10MB",
      });
      inputFile.value = "";
      return;
    }

    // validar imagen
    if (!file.type.startsWith("image/")) {
      Swal.fire({
        icon: "error",
        title: "Archivo no válido",
        text: "Selecciona una imagen",
      });
      inputFile.value = "";
      return;
    }

    Swal.fire({
      title: "Procesando imagen...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      // convertir HEIC
      if (
        file.type === "image/heic" ||
        file.type === "image/heif" ||
        file.name.toLowerCase().endsWith(".heic")
      ) {
        const converted = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5,
        });

        file = new File([converted], file.name.replace(/\.heic$/i, ".jpg"), {
          type: "image/jpeg",
        });
      }

      // reducir tamaño
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");

        const MAX_WIDTH = 1600;

        let width = img.width;
        let height = img.height;

        if (width > MAX_WIDTH) {
          const ratio = MAX_WIDTH / width;
          width = MAX_WIDTH;
          height = height * ratio;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            const compressedFile = new File([blob], "imagen.jpg", {
              type: "image/jpeg",
            });

            // 🔥 reemplazar archivo dentro del input
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(compressedFile);
            inputFile.files = dataTransfer.files;

            const preview = URL.createObjectURL(blob);

            Swal.close();

            Swal.fire({
              title: "¿Deseas subir esta imagen?",
              imageUrl: preview,
              showCancelButton: true,
              confirmButtonText: "Subir",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              customClass: {
                popup: "mi-popup",
                image: "mi-popup__imagen",
                confirmButton: "btnModal-confirmar",
                cancelButton: "btnModal-cancelar",
              },
            }).then((result) => {
              if (result.isConfirmed) {
                subirImagen(compressedFile);
              } else {
                inputFile.value = "";
              }
            });
          },
          "image/jpeg",
          0.85,
        );
      };
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo procesar la imagen",
      });
    }
  });

  function subirImagen(file) {
    // 🔥 modo demo
    if (esModoDemo(tokenActual)) {
      Swal.fire({
        title: "Subiendo imagen...",
        html: '<progress value="100" max="100" style="width:100%"></progress>',
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      setTimeout(() => {
        insertarFotoDemo(file);

        Swal.fire({
          icon: "success",
          title: "Imagen subida correctamente",
        });
      }, 1200);

      return;
    }

    const formData = new FormData();
    formData.append("imagen", file);
    formData.append("token", tokenActual);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "post.php", true);

    Swal.fire({
      title: "Subiendo imagen...",
      html: '<progress value="0" max="100" style="width:100%"></progress>',
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    const progress = document.querySelector("progress");

    xhr.upload.addEventListener("progress", function (e) {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        progress.value = percent;
      }
    });

    xhr.onload = function () {
      const respuesta = JSON.parse(xhr.responseText);

      if (respuesta.success) {
        const modoActivo = document.querySelector(".clasificacion_fotos.activo")
          .dataset.modo;
        cargarFotos(modoActivo);

        Swal.fire({
          icon: "success",
          title: "Imagen subida correctamente",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: respuesta.message,
        });
      }
    };

    xhr.send(formData);
  }

  function insertarFotoDemo(file) {
    const modoActivo = document.querySelector(".clasificacion_fotos.activo")
      .dataset.modo;
    const preview = URL.createObjectURL(file);

    // 🔥 guardar en memoria (base64)
    const reader = new FileReader();
    reader.onload = function (e) {
      const imagenBase64 = e.target.result;

      let fotosDemo = JSON.parse(localStorage.getItem("fotosDemo")) || [];
      fotosDemo.unshift(imagenBase64);

      localStorage.setItem("fotosDemo", JSON.stringify(fotosDemo));
    };
    reader.readAsDataURL(file);

    let lightgallery = document.getElementById("lightgallery");
    const contenedor = document.getElementById("catalogoContenedor");

    // si no existe lightgallery, crearlo igual que PHP
    if (!lightgallery) {
      contenedor.innerHTML = `
    <div id="lightgallery" class="catalogo__contenedor"></div>
  `;
      lightgallery = document.getElementById("lightgallery");
    }

    const html = `
    <div class="w-100 item">
      <div class="modelo card card-invitacion">
        <a href="${preview}" data-pswp-width="1600" data-pswp-height="1200">
          <img src="${preview}" class="card-img-top ${modoActivo === "mis" ? "misFotos" : ""}" alt="Fotos" loading="lazy">
        </a>
      </div>

      ${
        modoActivo === "mis"
          ? `
        <div class="w-100 d-flex justify-content-center align-items-center">
          <button class="btn btnBorrarFoto" data-id="demo">
            <span class="iconify" data-icon="proicons:delete" style="font-size:25px;"></span>
          </button>
        </div>
      `
          : ""
      }
    </div>
  `;

    // quitar leyenda vacía
    const leyenda = document.querySelector(".leyenda-vacio");
    if (leyenda) {
      leyenda.remove();
    }

    lightgallery.insertAdjacentHTML("afterbegin", html);

    iniciarScrollReveal();
    borrarFotos();

    if (window.initPhotoSwipe) {
      window.initPhotoSwipe();
    }
  }
}

function empiezaCargaFotos() {
  document.querySelector(".clasificacion_fotos.activo").click();

  // Opcíón del filtrado de las fotos
  document.querySelectorAll(".clasificacion_fotos").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const modo = this.dataset.modo;

      document
        .querySelectorAll(".clasificacion_fotos")
        .forEach((el) => el.classList.remove("activo"));

      this.classList.add("activo");

      // si entra a mis fotos → resetear filtro
      if (modo === "mis") {
        document.querySelectorAll(".filtroInvitado").forEach((select) => {
          select.value = "";
          select.classList.add("oculto");
        });

        cargarFotos(modo, "");
        return;
      }

      // si vuelve a todas → mostrar filtro
      document.querySelectorAll(".filtroInvitado").forEach((select) => {
        select.classList.remove("oculto");
      });

      const invitado = document.querySelector(".filtroInvitado").value;

      cargarFotos(modo, invitado);
    });
  });
}

function cargarFotos(modo = "todas", invitado = "") {
  fetch(
    `cargar_fotos.php?modo=${modo}&token=${tokenActual}&invitado=${invitado}`,
  )
    .then((res) => res.text())
    .then((html) => {
      document.getElementById("catalogoContenedor").innerHTML = html;
      if (esModoDemo(tokenActual)) {
        const fotosDemo = JSON.parse(localStorage.getItem("fotosDemo")) || [];

        fotosDemo.forEach((src) => {
          insertarFotoDesdeStorage(src, modo);
        });
      }
      iniciarScrollReveal();
      borrarFotos();
      const leyenda = document.querySelector(".leyenda-vacio");
      if (leyenda) {
        leyenda.addEventListener("click", function () {
          inputFile.click();
        });
      }

      if (window.initPhotoSwipe) {
        window.initPhotoSwipe();
      }
    });
}

function filtrosInvitados() {
  fetch(`cargar_invitados.php?token=${tokenActual}`)
    .then((res) => res.text())
    .then((html) => {
      document.querySelectorAll(".filtroInvitado").forEach((select) => {
        select.innerHTML += html;
      });
    });

  document.querySelector(".clasificacion_fotos.activo").click();

  document.querySelectorAll(".filtroInvitado").forEach((select) => {
    select.addEventListener("change", function () {
      const invitado = this.value;
      const modoActivo = document.querySelector(".clasificacion_fotos.activo")
        .dataset.modo;

      // sincroniza ambos selects
      document.querySelectorAll(".filtroInvitado").forEach((otro) => {
        otro.value = invitado;
      });

      cargarFotos(modoActivo, invitado);
    });
  });
}

function insertarFotoDesdeStorage(src, modoActivo) {
  let lightgallery = document.getElementById("lightgallery");
  const contenedor = document.getElementById("catalogoContenedor");

  if (!lightgallery) {
    contenedor.innerHTML = `<div id="lightgallery" class="catalogo__contenedor"></div>`;
    lightgallery = document.getElementById("lightgallery");
  }

  const html = `
    <div class="w-100 item">
      <div class="modelo card card-invitacion">
        <a href="${src}" data-pswp-width="1600" data-pswp-height="1200">
          <img src="${src}" class="card-img-top ${modoActivo === "mis" ? "misFotos" : ""}">
        </a>
      </div>

      ${
        modoActivo === "mis"
          ? `
        <div class="w-100 d-flex justify-content-center align-items-center">
          <button class="btn btnBorrarFoto" data-src="${src}">
            <span class="iconify" data-icon="proicons:delete" style="font-size:25px;"></span>
          </button>
        </div>
      `
          : ""
      }
    </div>
  `;

  lightgallery.insertAdjacentHTML("afterbegin", html);

  borrarFotos(); // 🔥 importante para reactivar eventos
}

function descargaFotos() {
  document
    .getElementById("btnDescargar")
    .addEventListener("click", function (e) {
      e.preventDefault();

      const modo = document.querySelector(".clasificacion_fotos.activo").dataset
        .modo;
      const invitado = document.querySelector(".filtroInvitado").value;

      window.location.href = `descargar_fotos.php?token=${tokenActual}&modo=${modo}&invitado=${invitado}`;
    });
}

function borrarFotos() {
  document.querySelectorAll(".btnBorrarFoto").forEach((btn) => {
    btn.addEventListener("click", function () {
      if (esModoDemo(tokenActual)) {
        const src = btn.dataset.src;

        let fotosDemo = JSON.parse(localStorage.getItem("fotosDemo")) || [];

        fotosDemo = fotosDemo.filter((img) => img !== src);

        localStorage.setItem("fotosDemo", JSON.stringify(fotosDemo));

        btn.closest(".item").remove();

        return;
      }
      const idFoto = this.dataset.id;

      Swal.fire({
        title: "¿Eliminar foto?",
        text: "Esta acción no se puede deshacer",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Sí, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          if (esModoDemo(tokenActual)) {
            Swal.fire({
              icon: "success",
              title: "Foto eliminada",
              timer: 1200,
              showConfirmButton: false,
            });

            btn.closest(".item").remove();
            return;
          }

          fetch("borrar_foto.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: `id=${idFoto}`,
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                Swal.fire({
                  icon: "success",
                  title: "Foto eliminada",
                  timer: 1200,
                  showConfirmButton: false,
                });

                // quitar del DOM
                btn.closest(".item").remove();
              } else {
                Swal.fire("Error", data.message, "error");
              }
            });
        }
      });
    });
  });
}

function cierraAlertaExpiracion() {
  const modalDudas = document.getElementById("modalDudas");
  const videoDudas = document.getElementById("videoDudas");
  const alertaExpirara = document.getElementById("alertaExpirara");
  const cerrarAlertaExpirara = document.getElementById("cerrarAlertaExpirara");

  if (modalDudas && videoDudas) {
    modalDudas.addEventListener("shown.bs.modal", function () {
      const playPromise = videoDudas.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    });

    modalDudas.addEventListener("hide.bs.modal", function () {
      const triggerButton = document.getElementById("btnDudas");

      videoDudas.pause();

      if (modalDudas.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      triggerButton?.focus();
    });
  }

  cerrarAlertaExpirara?.addEventListener("click", function () {
    alertaExpirara?.remove();
  });
}

function contadorAlertaExpiracion() {
  const alertaExpirara = document.getElementById("alertaExpirara");
  const textoAlertaExpirara = document.getElementById("textoAlertaExpirara");
  const cerrarAlertaExpirara = document.getElementById("cerrarAlertaExpirara");

  if (alertaExpirara && textoAlertaExpirara) {
    const expiracion = Number(alertaExpirara.dataset.expiracion) * 1000;
    const umbral = Number(alertaExpirara.dataset.umbral) * 1000;

    const actualizarAlertaExpiracion = function () {
      const restante = expiracion - Date.now();

      if (restante <= 0 || restante > umbral) {
        alertaExpirara.style.display = "none";
        return;
      }

      const totalMinutos = Math.floor(restante / 60000);
      const dias = Math.floor(totalMinutos / 1440);
      const horas = Math.floor((totalMinutos % 1440) / 60);
      const minutos = totalMinutos % 60;

      const textoDias = dias === 1 ? "1 día" : `${dias} días`;
      const textoHoras = horas === 1 ? "1 hora" : `${horas} horas`;
      const textoMinutos = minutos === 1 ? "1 minuto" : `${minutos} minutos`;

      textoAlertaExpirara.textContent = `Las fotografías expirarán en ${textoDias}, ${textoHoras} y ${textoMinutos}, por favor descarga tu álbum lo antes posible`;
      alertaExpirara.style.display = "block";
    };

    actualizarAlertaExpiracion();
    setInterval(actualizarAlertaExpiracion, 60000);

    cerrarAlertaExpirara?.addEventListener("click", function () {
      alertaExpirara.remove();
    });
  }
}
